export const accountPhotoURL = '/avatar_default.jpg';
